import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { FlLoadingComponent } from './components/fl-loading/fl-loading.component';
import { FlLoadingDirective } from './fl-loading.directive';
import { loadingFactoryProvider } from './fl-loading.factory';
import { loadingProvider } from './fl-loading.service';

const flLoading = [FlLoadingComponent, FlLoadingDirective];

@NgModule({
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    OverlayModule,
    PortalModule,
  ],
  declarations: [flLoading],
  exports: [flLoading],
  providers: [loadingFactoryProvider, loadingProvider],
})
export class FlLoadingModule {}
